module.exports = __webpack_public_path__ + "img/STD13212.97a269ec.jpg";